module.exports = __webpack_public_path__ + "img/noCoupon.4c07e3f0.png";